import templateGet from './get/template.html';
import controllerGet from './get/controller';
import templateActivity from './activity/template.html';
import controllerActivity from './activity/controller';

const usersActivitiesActivityState = {
  url: '/:activity_id',
  stateName: 'Activity',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: templateActivity,
      controller: controllerActivity,
      controllerAs: 'userActivityCtrl'
    }
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    PreviousState: /* @ngInject */ ResolveClass => ResolveClass.previousStateInfo(),
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/activities/:id'),
  }
};

const usersActivitiesState = {
  url: '/activities?view',
  stateName: 'User Activities',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: false,
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/activities'),
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin(true, 'admin.activities');
    }
  },
  views: {
    'a@app': {
      template: templateGet,
      controller: controllerGet,
      controllerAs: 'userActivitiesCtrl'
    }
  }
};

export { usersActivitiesState, usersActivitiesActivityState };



// WEBPACK FOOTER //
// ./src/app/controllers/users/activities/index.js